import { ViewTrainingEventReport as ViewItems } from '@aims/shared/reports';
import React from 'react';
import { useParams } from 'react-router-dom';
import CSPage from '../../../components/CSPage';
import CSPageHeader from '../../../components/CSPageHeader';
import useReport from './use-report';

const queryId = 'viewTrainingEventReport';

function ViewTrainingEventReport() {
  const { reportId } = useParams();
  const { report, loading } = useReport(reportId, queryId, true);

  return (
    <CSPage title={`AIMS.org | View Training Event Report`}>
      <CSPageHeader
        title="View Training Event Report"
        parents={[
          {
            label: 'Training',
            link: `/training`,
          },
          {
            label: 'Event Reports',
            link: `/training-reports/event`,
          },
        ]}
      />
      {report && (
        <div style={{ maxWidth: 800, marginLeft: 'auto', marginRight: 'auto' }}>
          <ViewItems report={report} />
        </div>
      )}
    </CSPage>
  );
}

export default ViewTrainingEventReport;
